import React from 'react';

class UpdatePaymentError extends React.Component {
  render() {
    return (
      <div className='update-card-container flex-column'>
        <div className='full-scene flex-column'>
          <img
            src={require('../../images/error.png')}
            className='error-icon'
          />
          <div className='status-text'>
            Sorry something went wrong, please email support@trybe.do for assistance.
          </div>
        </div>
      </div>
    );
  }
}

module.exports = UpdatePaymentError;


// WEBPACK FOOTER //
// ./src/components/payments/UpdatePaymentError.js